import React, { useState, useEffect, useRef } from "react";
import { SlickCarrusel } from "./Components/Home/SlickCarrusel";
import { Carrusel } from "./Components/Home/Carrusel";
import { Carrusel2 } from "./Components/Home/Carrusel";
import { Carrusel2En } from "./Components/Home/Carrusel";
import { CarruselEn } from "./Components/Home/Carrusel";
import { Info } from "./Components/Home/Info";
import { useTranslation } from "react-i18next";
import OurServices from './Components/Home/OurServices'
import Ebook from './Components/Home/Ebook'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileArrowDown } from '@fortawesome/free-solid-svg-icons'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import Banner from "./Components/Home/Banner";
import CardBanner from "./Components/Home/CardBanners";
import FlowChartComp from "./Components/Home/FlowChartComp";
import SolutionsComp from "./Components/Home/SolutionsComp";
import UsComp from "./Components/Home/UsComp";
import { Diagram } from "./Components/Diagram";
import { Dynamic } from './Components/Home/Dynamic'

import { Dynamic365 } from "./Components/Home/Dynamic365";

import { Header } from './Header';
import { Footer } from "./Components/Footer";
import { ToggleComp } from "./Components/ToggleComp";

const Revolverimg = 'https://cdn.redinet.us/Home/Revolver-img.webp'
const ImgHome0Pt = "https://cdn.redinet.us/Home/Home0_pt.webp";
const ImgHome0 = "https://cdn.redinet.us/Home/New/HomeCarouse_Esp.webp";
const ImgHome0En = "https://cdn.redinet.us/Home/Home0_en.webp";
const ImgHome1 = "https://cdn.redinet.us/Home/New/HomeCarouse_Esp2.webp";
const ImgMap = "https://cdn.redinet.us/map_es.webp";
const ImgMapMobile = "https://cdn.redinet.us/map_mobile.webp";
const ImgHome1En = "https://cdn.redinet.us/Home/Home En.webp";
const ImgHome3 = "https://cdn.redinet.us/Home2Movil.webp";
const ImgHome3m = "https://cdn.redinet.us/Home/Home_azul.webp";
const ImgHome3mEn = "https://cdn.redinet.us/Home/Home0_pt.webp";
const ImgHome3En = "https://cdn.redinet.us/Home2MovilEn.webp";
const ImgHome2 = "https://cdn.redinet.us/Home/New/HomeCarouse_Esp3.webp";
const ImgHome2En = "https://cdn.redinet.us/Home/Carrusel 2 En.webp";
const ImgHome4 = "https://cdn.redinet.us/HomeMovil.webp";
const ImgHome4En = "https://cdn.redinet.us/HomeMovilEn.webp";
const Forcepoint = 'https://cdn.redinet.us/Home/Forcepoint color.webp';
const Microsoft = 'https://cdn.redinet.us/Home/Microsoft color.webp';
const Kaspersky = 'https://cdn.redinet.us/Home/Kaspersky.webp';

const Aruba = 'https://cdn.redinet.us/Home/Aruba.webp';
const DellEMC = 'https://cdn.redinet.us/Home/Dell.webp';
const Fortinet = 'https://cdn.redinet.us/Home/Fortinet.webp';
const Lenovo = 'https://cdn.redinet.us/Home/Lenovo.webp';
const TecTime = 'https://cdn.redinet.us/Home/Tecdime.webp';
const TrippLite = 'https://cdn.redinet.us/Home/Tripp-Lite.webp';


const Google = 'https://cdn.redinet.us/Home/Google color.webp';
const Azure = 'https://cdn.redinet.us/Home/Logos_multinubes-01.webp';
const AWS = 'https://cdn.redinet.us/Home/AWS color.webp'
const CISCO = 'https://cdn.redinet.us/Home/Cisco color.webp'
const HP = 'https://cdn.redinet.us/Home/HP color.webp'
const IBM = 'https://cdn.redinet.us/Home/IBM color.webp'
const Veritas = 'https://cdn.redinet.us/Home/Veritas color.webp'
const Trend = 'https://cdn.redinet.us/Home/Trend color.webp'
const Promo = 'https://cdn.redinet.us/Home/Promo.webp'



export function App() {
  const domainName = window.location.hostname;

  const [t, i18n] = useTranslation('common');

  const imga = [
    { img: Microsoft, alt: "Microsoft" },
    { img: Kaspersky, alt: "Kaspersky" },
    { img: Forcepoint, alt: "FORCEPOINT" },
    { img: CISCO, alt: "CISCO" },
    { img: HP, alt: "HP", clase: "img-HP" },
    { img: IBM, alt: "IBM" }
  ];

  const imga2 = [{
    img: Veritas, alt: "Veritas"
  },
  { img: Trend, alt: "Trend" },
  { img: Aruba, alt: "Aruba" },
  { img: DellEMC, alt: "DellEMC" },
  { img: Fortinet, alt: "Fortinet" },
  { img: Lenovo, alt: "Lenovo" },
  { img: TecTime, alt: "TecTime" },
  { img: TrippLite, alt: "TrippLite" }];

  const CarruselHome = [
    { src: ImgHome0, alt: "Home1", Id: 1, clase: "carousel-item active", btnText: `${t('home.btn')}`, btnSrc: "/Education" },
    { src: ImgHome1, alt: "Home2", Id: 2, clase: "carousel-item", btnText: `${t('home.btn')}`, btnSrc: "/Nosotros" },
    { src: ImgHome2, alt: "Home3", Id: 3, clase: "carousel-item", btnText: `${t('home.btn')}`, btnSrc: "/services-in-a-box" }];

  const CarruselHomeEn = [
    { src: ImgHome0En, alt: "Home1", Id: 1, clase: "carousel-item active", btnText: `${t('home.btn')}`, btnSrc: "/Education" },
    { src: ImgHome1En, alt: "Home2", Id: 2, clase: "carousel-item active", btnText: `${t('home.btn')}`, btnSrc: "/Nosotros" },
    { src: ImgHome2En, alt: "Home3", Id: 3, clase: "carousel-item", btnText: `${t('home.btn')}`, btnSrc: "/services-in-a-box" }];

  const CarruselHomePt = [
    { src: ImgHome0Pt, alt: "Home1", Id: 1, clase: "carousel-item active", btnText: `${t('home.btn')}`, btnSrc: "/Education" },
    { src: ImgHome1En, alt: "Home2", Id: 2, clase: "carousel-item active", btnText: `${t('home.btn')}`, btnSrc: "/Nosotros" },
    { src: ImgHome2En, alt: "Home3", Id: 3, clase: "carousel-item", btnText: `${t('home.btn')}`, btnSrc: "/services-in-a-box" }];

  const CarruselHome2 = [
    { src: ImgHome3m, alt: "Home4", Id: 4, clase: "carousel-item active", btnText: `${t('home.btn')}`, btnSrc: "/Education" }];

  const CarruselHome2En = [
    { src: ImgHome3mEn, alt: "Home4", Id: 4, clase: "carousel-item active", btnText: `${t('home.btn')}`, btnSrc: "/Education" },
    { src: ImgHome3En, alt: "Home1", Id: 5, clase: "carousel-item active", btnText: `${t('home.btn')}`, btnSrc: "/Nosotros" },
    { src: ImgHome4En, alt: "Home2", Id: 6, clase: "carousel-item", btnText: `${t('home.btn')}`, btnSrc: "/services-in-a-box" }];

  const CarruselHome2Pt = [
    { src: ImgHome3mEn, alt: "Home4", Id: 4, clase: "carousel-item active", btnText: `${t('home.btn')}`, btnSrc: "/Education" },
    { src: ImgHome3En, alt: "Home1", Id: 5, clase: "carousel-item active", btnText: `${t('home.btn')}`, btnSrc: "/Nosotros" },
    { src: ImgHome4En, alt: "Home2", Id: 6, clase: "carousel-item", btnText: `${t('home.btn')}`, btnSrc: "/services-in-a-box" }];


  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });

    return () => {

    }
  }, []);
  return (
    <div>
      <div className="elfsight-app-40fb1e62-3920-4974-9d3e-200370e63019" data-elfsight-app-lazy></div>
      <Header />
      {/*"Section Banner"*/}
      <Banner />
      {/*"Section Card Banner"*/}
      <CardBanner />
      {/*"Section Imagen Flujo"*/}
      {/*<FlowChartComp /> */}
      <Diagram text="Hola">
        <img src={Revolverimg} alt="image" />
      </Diagram>
      {/*"Section Our Services"*/}
      <OurServices />
      <SolutionsComp />
      {/*"Section Solutions"*/}
      {/*<Dynamic/>*/}
      {/*"Section UsComp"*/}
      <UsComp />
      <Dynamic365 />


      {/*"Section Marcas"*/}
      <SlickCarrusel img={imga} imga2={imga2} />

      <ToggleComp />
      <Footer />
    </div>
  )
}